import { WebsocketStateCode } from "../types";
import { AWebsocketState } from "./AWebsocketState";
import { ConnectedState } from "./ConnectedState";
import { DisconnectedState } from "./DisconnectedState";

export class ConnectingState extends AWebsocketState {
  override onOpen(): void {
    this.client.resetReconnectAttempt();
    this.client.setState(new ConnectedState(this.client));
  }

  override onClose(ev: CloseEvent): void {
    console.log("ConnectingState: socket closed", ev.code, ev.reason);
    this.client.setState(new DisconnectedState(this.client));
  }

  override disconnect(): void {
    this.client.getWebsocket()?.close(WebsocketStateCode.NORMAL_CLOSURE, "client cancel");
  }
}
